import React from 'react';
import { hot } from 'react-hot-loader/root';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { UserDetailsPage } from '../';
import AddUserPage from '../AddUserPage';
import routes from '../routes';
import MyOrganisationPage from './MyOrganisationPage';

const MyOrganisationEntry: React.FC = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.url}/users/add`} exact component={AddUserPage} />
      <Route
        path={`${match.url}/users/:UID`}
        exact
        component={UserDetailsPage}
      />
      <Route
        path={routes.MyOrganisation.path}
        exact
        component={MyOrganisationPage}
      />
      <Route path={`${match.url}`}>
        <Redirect to="/organisation" />
      </Route>
    </Switch>
  );
};

export default hot(MyOrganisationEntry);
